import { Typography } from '@material-ui/core';
import React from 'react';
import { Faq } from '../components/Faq';
import { Headline } from '../components/Headline';
import PageHead from '../components/PageHead';
import { PricingTable } from '../components/PricingTable';
import { SEO } from '../components/SEO';
import ContentLayout from '../layouts/main';

export default () => {
  return (
    <ContentLayout>
      <>
        <SEO
          title="Affilimate Pricing"
          description="Learn about Affilimate's different pricing plans, and find one that suits your business no matter what stage you're at."
          pathname="/pricing/"
        />
        <PageHead>
          <Headline
            variant="h1"
            gutterBottom
            component="h1"
            style={{
              maxWidth: '700px',
              margin: '0 auto 36px',
              fontWeight: 900
            }}
          >
            Plans tailored to your business
          </Headline>
          <Typography
            variant="h6"
            gutterBottom
            component="p"
            color="textSecondary"
            style={{
              maxWidth: '700px',
              margin: '0 auto 36px'
            }}
          >
            What category does your business fall into?
          </Typography>
          <PricingTable />
        </PageHead>
      </>
      <Faq />
      <br />
      <br />
      <br />
      <br />
    </ContentLayout>
  );
};
